import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';
import { ApiService } from '../../services/api.service';
import { catchError, of } from 'rxjs';
export const companiesResolver: ResolveFn<{
  company_id: string;
  company_name: string;
  company_groups: {
      company_group_id: number;
      company_group_name: string;
  }[];
}[]> = (route, state) => {
  const api = inject(ApiService);
  // const idb = inject(IndexedStorageService);
  return api.builderCompanies().pipe(
    catchError(err=>{console.log(`[companiesResolver]`, err);return of([])})
  )
  // .pipe(
  //   tap(companies=>idb.storeEmpreses(companies).subscribe({
  //     next:(resp)=>console.log('[companiesResolver idb] ', resp)
  //   })),
  // )
};
